export default [{
    header: 'Proveedores',
    icon: 'BriefcaseIcon',
    children: [
        {
            title: 'Lista',
            route: 'providers-list',
            icon: 'ListIcon',
            action: 'read',
		    resource: 'providers'
        },
        {
            title: 'Agregar',
            route: 'providers-create',
            icon: 'PlusSquareIcon',
            action: 'create',
		    resource: 'providers'
        }
    ]
}];